// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomButtons_wrapper__Nz4QZ","left":"BottomButtons_left__1M9LC","right":"BottomButtons_right__kH4dj"};